import { t } from "@lingui/macro";
import { atom, useAtomValue } from "jotai";
import { useState } from "react";
import { ScrollView } from "react-native";

import {
  Box,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { VerificationModalStepStateAtom } from "../../../../atoms/stores";
import { LearnMore } from "../LearnMore/LearnMore";
import { ClubSelectionResults } from "./components/ClubSelectionResults";
import { ClubSelectionResultsSkeleton } from "./components/ClubSelectionResultsSkeleton";
import { ClubSelectionSearchInput } from "./components/ClubSelectionSearchInput";
import { usePublicClubsSearch } from "./hooks/usePublicClubsSearch";

const verificationStepDataAtom = atom((get) => {
  const state = get(VerificationModalStepStateAtom);
  if (state.step === "ClubSelection") {
    return {
      emailOrPhone: state.emailOrPhone,
    };
  }
  return null;
});

export const ClubSelectionStep = () => {
  const [value, setValue] = useState("");
  const { results, isLoading } = usePublicClubsSearch(value);
  const verificationStepData = useAtomValue(verificationStepDataAtom);

  return (
    <ScrollView
      showsVerticalScrollIndicator={false}
      keyboardShouldPersistTaps="handled"
    >
      <VStack paddingHorizontal={6} paddingBottom={3} flexGrow={1}>
        <VStack gap={2}>
          <Text
            variant={"mainBaseMedium"}
            color="text-secondary"
          >{t`Welcome to Whoosh!`}</Text>
          <Text variant={"mainTitle3"}>{t`Where do you want to book?`}</Text>
        </VStack>
        <ClubSelectionSearchInput value={value} setValue={setValue} />

        {isLoading ? (
          <ClubSelectionResultsSkeleton />
        ) : (
          <ClubSelectionResults
            results={results}
            searchString={value}
            emailOrPhone={verificationStepData?.emailOrPhone ?? null}
          />
        )}

        {!isLoading && (value.length === 0 || results.length === 0) ? (
          <Box marginTop={6}>
            <LearnMore
              emailOrPhone={verificationStepData?.emailOrPhone ?? null}
            />
          </Box>
        ) : null}
      </VStack>
    </ScrollView>
  );
};
